import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Modal (spec §4 / §7). role=dialog + aria-modal, labelled by its title, Esc closes,
 * overlay click closes. Icon-only close carries an aria-label.
 */
const Modal = ({ open, onClose, title, children, footer, className = '' }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4"
      role="dialog"
      aria-modal="true"
      aria-label={typeof title === 'string' ? title : undefined}
    >
      <div
        className="fixed inset-0 bg-[rgba(10,37,64,.32)] backdrop-blur-[5px]"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={[
          'relative my-8 w-full max-w-[740px] bg-arc-card rounded-[22px] shadow-arc-lg overflow-hidden',
          className,
        ].join(' ')}
      >
        {title && (
          <div className="sticky top-0 z-10 arc-blur-card border-b border-arc-line px-[30px] py-[22px] flex items-center justify-between">
            <h2 className="text-h2 text-arc-ink">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close dialog"
              className="-mr-2 p-2 rounded-arc-ctl text-arc-ink-3 hover:text-arc-ink hover:bg-arc-paper-2 transition"
            >
              <X size={18} />
            </button>
          </div>
        )}
        <div className="p-[30px]">{children}</div>
        {footer && <div className="px-[30px] py-[22px] border-t border-arc-line">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
